import React from 'react';
import { ArcMapEventProps } from './types';
import { useGoogleMap } from '@react-google-maps/api';

const ArcMapEvent: React.FC<ArcMapEventProps> = (props) => {
  const { eventName, handler } = props;

  const map = useGoogleMap();
  const callbackRef = React.useRef(handler);

  React.useEffect(() => {
    callbackRef.current = handler;
  }, [handler]);

  React.useEffect(() => {
    
    if (!map || !eventName) return;

    const handler = (...args: any[]) => {
      if (callbackRef.current) {
        callbackRef.current(...args);
      }
    };

    const listener = map.addListener(eventName, handler);

    return () => {
      google.maps.event.removeListener(listener);
    };

  }, [map, eventName]);

  return null;
};

export default ArcMapEvent;